import { useTranslate } from 'srs.sharedcomponents/lib/esm/hooks/useTranslate';
import * as S from './styles';
import { useHistory } from 'react-router-dom';


const ChooseLogin = () => {
  const history = useHistory();
  const fordTechServiceUrl = (globalThis as any).env?.REACT_APP_FORDTECHSERVICE_URL || '';
  const { translate } = useTranslate();

  const handleLogin = (userType: string) => {
    //open external link
    switch (userType) {
      case 'Ford Dealer':
        globalThis.location.href = fordTechServiceUrl;
        break;
      case 'Lincoln Dealer':
        globalThis.location.href = fordTechServiceUrl
        break;
      case 'Ford Authorized Fleet':
        globalThis.location.href = fordTechServiceUrl;
        break;
      case 'Retail':
        history.push('/retail-login');
        break;
      case 'Guest':
        history.push('/');
        break;
      default:
        break;
    }
  };

  return (
    <S.LoginContainer data-cy="choose-login-wrapper">
      <S.Center data-cy="choose-login-center">
        <S.H1Style data-cy="choose-login-header">
          {translate('txtWelcomeMessage')}
        </S.H1Style>
        <S.ParaGraph data-cy="choose-login-paragraph">
          {translate('loginChoose.descriptionText')}
        </S.ParaGraph>
        <S.ButtonsContainer data-cy="choose-login-buttons">
          <S.Button onClick={() => handleLogin('Ford Dealer')} id="loginFordDealer">
            {translate('loginChoose.btnFordDealer')}
          </S.Button>
          <S.Button onClick={() => handleLogin('Lincoln Dealer')} id="loginLincolnDealer">
          {translate('loginChoose.btnLincolnDealer')}
          </S.Button>
          <S.Button onClick={() => handleLogin('Ford Authorized Fleet')} id="loginFordAuthorizedFleet">
            {translate('loginChoose.btnFordAuthorizedFleet')}
          </S.Button>
          <S.Button onClick={() => handleLogin('Retail')} id="loginRetail">
            {translate('loginChoose.btnRetail')}
          </S.Button>
          <S.Button onClick={() => handleLogin('Guest')} id="loginGuest">
            {translate('loginChoose.btnGuest')}
          </S.Button>
        </S.ButtonsContainer>
      </S.Center>
    </S.LoginContainer>
  );
};

export default ChooseLogin;